export function isValidIPv4(value: string): boolean {
  return /^((25[0-5]|2[0-4][0-9]|1{0,1}[0-9]{1,2})\.){3}(25[0-5]|2[0-4][0-9]|1{0,1}[0-9]{1,2})$/.test(
    value,
  );
}

export function isValidIPv6(value: string): boolean {
  return /^((([0-9A-Fa-f]{1,4}:){1,6}:)|(([0-9A-Fa-f]{1,4}:){7}))([0-9A-Fa-f]{1,4})$/.test(value);
}

export function isValidDnsName(value: string, allowApex = false, allowRoot = false): boolean {
  const name = value.trim();

  if (allowApex && (!name || name === '@')) {
    return true;
  }

  if (allowRoot && name === '.') {
    return true;
  }

  if (!name || name.length > 253) {
    return false;
  }

  return name
    .split('.')
    .every((label) => /^[A-Za-z0-9_](?:[A-Za-z0-9_-]{0,61}[A-Za-z0-9_])?$/.test(label));
}
